import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitMode = createSelector(
  [selectFinancialCockpitState],
  ({ cockpitMode }) => cockpitMode
)
